module.exports = __webpack_public_path__ + "static/media/POPCORN_BAG.916c70d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/POPCORN_BAG.png
// module id = 159
// module chunks = 0